export const REQUIRES_VERIFY_MESSAGE = `Portal session requires verification.`;
//# sourceMappingURL=portal.js.map